import { Component } from "react";
import { INavigationParcours, obtenirNavigationUrl } from "../../../util/Navigation";
import * as CONFIG_GABARIT_GLOBAL from "../../../GabaritGlobalConfig";
import { getMetaTagContent } from "../../../scripts/getMetaTag";
import { loadNavigationScripts } from "../../../scripts/loadNavigationScripts";
import "./Content.css";
import ServiceAssurabiliteBFF from "../../utils/ServiceAssurabiliteBFF";
import { InformationsPreAssurabilite } from "../../../models/informations-pre-assurabilite";
import i18n from "../../../resources/I18n";
import * as TYPE_PARCOURS from "../../../constants/typeParcours";
import Questionnaire from "./Questionnaire";
import ModalLoadingAMC from "./../ModalLoadingAMC";
import SpanAlerte from "../../APRHN/SpanAlerte";
import StepIndicator from "./StepIndicator";
import Boutons from "./Boutons";
import ClickToCall from "../ClickToCall";
import { CybermetriesAMC } from "../../../util/CybermetrieAMC";

interface IContentProps {
  cookieParcoursAssurance: INavigationParcours;
  parcours: string;
}

interface IContentState {
  informationsPreAssurabilite: InformationsPreAssurabilite;
  isApp: boolean;
  redirigerVersErreur: boolean;
  enChargement: boolean;
  stateQuestionnaireSoumis: boolean;
  enChargementQuestion: boolean;
  erreurStatut: number;
  modaleEnregistrerOuvert: boolean;
  declencheurModaleEnregistrer: string;
  modaleAnnulerOuvert: boolean;
  declencheurModaleAnnuler: string;
  modaleDonnerControleOuvert: boolean;
  declencheurModaleDonnerControle: string;
}

class Content extends Component<IContentProps, IContentState> {
  ServiceAssurabiliteBFF: ServiceAssurabiliteBFF;

  constructor(props: any) {
    super(props);
    this.state = {
      informationsPreAssurabilite: {},
      isApp: false,
      redirigerVersErreur: false,
      enChargement: false,
      stateQuestionnaireSoumis: false,
      enChargementQuestion: false,
      erreurStatut: 0,
      modaleEnregistrerOuvert: false,
      declencheurModaleEnregistrer: "",
      modaleAnnulerOuvert: false,
      declencheurModaleAnnuler: "",
      modaleDonnerControleOuvert: false,
      declencheurModaleDonnerControle: "",
    };

    this.ServiceAssurabiliteBFF = new ServiceAssurabiliteBFF();
    this.onClickEtatModaleEnregistrer = this.onClickEtatModaleEnregistrer.bind(this);
    this.onClickEtatModaleAnnuler = this.onClickEtatModaleAnnuler.bind(this);
    this.onClickEtatModaleDonnerControle = this.onClickEtatModaleDonnerControle.bind(this);
  }

  async componentDidMount() {
    let cookieParcoursAssurance = this.props.cookieParcoursAssurance;

    if (!cookieParcoursAssurance) {
      // Page erreur
    } else if (!cookieParcoursAssurance.idSouscription || !cookieParcoursAssurance.idAssure) {
      // Page erreur
    } else {
      this.setState({ enChargement: true });
      await this.ServiceAssurabiliteBFF.effectuerAppelPostDemarrerPreAssurabilite(
        cookieParcoursAssurance.idSouscription,
        cookieParcoursAssurance.idAssure,
        cookieParcoursAssurance.langue,
        this.succesAppelPostDemarrerPreAssurabilite,
        this.erreurAppelBFF,
        cookieParcoursAssurance.idCallback
      );
    }

    this.setState({ isApp: getMetaTagContent("oel-is-app") !== null ? getMetaTagContent("oel-is-app") : false });
    loadNavigationScripts("AMC");
  }

  succesAppelPostDemarrerPreAssurabilite = (reponse: { data: InformationsPreAssurabilite }) => {
    this.setState({ informationsPreAssurabilite: reponse.data, enChargement: false }, () => {
      const { cookieParcoursAssurance } = this.props;
      const assure = this.state.informationsPreAssurabilite.assures?.find(
        (a: any) => a.id === cookieParcoursAssurance.idAssure
      );
      if (
        !assure ||
        (!this.state.informationsPreAssurabilite.exigence && !this.state.informationsPreAssurabilite.decision)
      ) {
        this.setState({ redirigerVersErreur: true });
      }
      this.chargerTitrePage();
      CybermetriesAMC.EnvoieAffichagePageValidation(this.creeCybermetrieParams(this.state.informationsPreAssurabilite));
    });
  };

  erreurAppelBFF = (reponse: any) => {
    this.setState({ redirigerVersErreur: true, enChargement: false });
  };

  chargerTitrePage = () => {
    const isApp = getMetaTagContent("oel-is-app") === "true";
    const estNouvelleMarge = this.state.informationsPreAssurabilite.estNouvelleMarge;

    let titre = "";
    if (isApp) {
      titre = estNouvelleMarge
        ? i18n.t("amc-validation:titre-webview-nouvelle-marge")
        : i18n.t("amc-validation:titre-webview-limite-credit");
    } else {
      titre = estNouvelleMarge
        ? i18n.t("amc-validation:titre-web-nouvelle-marge")
        : i18n.t("amc-validation:titre-web-limite-credit");
    }
    document.title = titre;
  };

  onClickContinuer = () => {
    this.setState({ stateQuestionnaireSoumis: true });
    const { parcours, cookieParcoursAssurance } = this.props;

    const url = obtenirNavigationUrl(cookieParcoursAssurance.idCallback);
    const urlParams = `${parcours}/${cookieParcoursAssurance.langue}/next?idSouscription=${cookieParcoursAssurance.idSouscription}&idAssure=${cookieParcoursAssurance.idAssure}&isApp=${this.state.isApp}`;
    window.location.assign(url + urlParams);
  };

  handleCloseModale(declencheur: string, btnId: string) {
    let elementRetour: HTMLElement | null = null;
    if (declencheur === "btn-evenement-retour") {
      elementRetour = document
        .getElementsByTagName("oel-header-transactionnel")[0]
        .shadowRoot.getElementById("btn-evenement-retour");
    } else {
      elementRetour = document.getElementById(btnId)?.getElementsByClassName("button")[0] as HTMLElement;
    }

    setTimeout(() => {
      document.getElementById(btnId)?.querySelector("button")?.removeAttribute("tabIndex");
      document.getElementsByTagName("oel-header-transactionnel")[0]?.removeAttribute("tabIndex");
      elementRetour?.focus();
    }, 1);
  }

  onClickEtatModaleEnregistrer(etat: boolean, declencheur: string) {
    this.setState({ modaleEnregistrerOuvert: etat });
    if (etat) {
      this.setState({ declencheurModaleEnregistrer: declencheur });
    } else {
      const trigger = declencheur || this.state.declencheurModaleEnregistrer;
      this.handleCloseModale(trigger, "btn-enregistrer-amc");
    }
  }

  onClickEtatModaleAnnuler(etat: boolean, declencheur: string) {
    this.setState({ modaleAnnulerOuvert: etat });
    if (etat) {
      this.setState({ declencheurModaleAnnuler: declencheur });
    } else {
      const trigger = declencheur || this.state.declencheurModaleAnnuler;
      this.handleCloseModale(trigger, "btn-annuler-amc");
    }
  }

  onClickEtatModaleDonnerControle(etat: boolean, declencheur: string) {
    this.setState({ modaleDonnerControleOuvert: etat });
    if (etat) {
      this.setState({ declencheurModaleDonnerControle: declencheur });
    } else {
      const trigger = declencheur || this.state.declencheurModaleDonnerControle;
      this.handleCloseModale(trigger, "btn-donner-controle-amc");
    }
  }

  creeCybermetrieParams(informationsPreassurabilite: InformationsPreAssurabilite) {
    const { idAssure } = this.props.cookieParcoursAssurance;
    const assures = informationsPreassurabilite.assures || [];
    const assure = assures.find((a: any) => a.id === idAssure);
    return {
      estEmprunteurUnique: assures.length === 1,
      estEmprunteurPrimaire: assure?.indicateurEmprunteurPrimaire === true,
      estNouvelleMarge: informationsPreassurabilite.estNouvelleMarge,
      parcours: this.props.parcours,
      noDemande: informationsPreassurabilite.noDemande,
    };
  }

  render() {
    if (this.state.redirigerVersErreur) {
      const url = `${obtenirNavigationUrl(this.props.cookieParcoursAssurance.idCallback)}${this.props.parcours}/${
        this.props.cookieParcoursAssurance.langue
      }/error?idSouscription=${this.props.cookieParcoursAssurance.idSouscription}&idAssure=${
        this.props.cookieParcoursAssurance.idAssure
      }`;
      window.location.replace(url);
      return null;
    }
    return (
      <gabarit-global configuration={CONFIG_GABARIT_GLOBAL.config}>
        <div id="contenu-principal-validation-amc">
          <main className="dsd-custom-grid">
            {this.state.enChargementQuestion && <ModalLoadingAMC />}
            {!this.state.enChargementQuestion && <SpanAlerte>{i18n.t("sr-only-chargement-termine")}</SpanAlerte>}
            <dsd-grid class="dsd-fg-1 dsd-d-flex dsd-fd-col">
              <dsd-grid-row class="md:dsd-fg-1">
                <dsd-grid-col
                  col="12"
                  md-col="4"
                  lg-col="3"
                  class="md:dsd-fg-1 md:dsd-d-flex dsd-custom-grid-left-column"
                >
                  <div className="dsd-d-flex dsd-fg-1 dsd-p-md dsd-pt-sm dsd-pb-sm dsd-w-100">
                    {this.state.informationsPreAssurabilite.estNouvelleMarge != null && (
                      <StepIndicator estNouvelleMarge={this.state.informationsPreAssurabilite.estNouvelleMarge} />
                    )}
                  </div>
                </dsd-grid-col>
                <dsd-grid-col col="12" md-col="8" lg-col="9" class="md:dsd-fg-1">
                  <div className="amc-contenu-validation">
                    <div className="entete-validation">
                      <h2 data-testid="titre-validation-validation" id="titre-validation-validation">
                        {i18n.t("amc-validation:titre-validation")}
                      </h2>
                      <p data-testid="texte-validation-validation" className="texte-validation-validation">
                        {i18n.t("amc-validation:texte-validation")}
                      </p>
                    </div>
                    <div className="questionnaire">
                      <Questionnaire
                        informationsPreAssurabilite={this.state.informationsPreAssurabilite}
                        enChargement={this.state.enChargement}
                        idAssure={this.props.cookieParcoursAssurance.idAssure}
                        parcours={this.props.parcours}
                        cookieParcoursAssurance={this.props.cookieParcoursAssurance}
                      />
                      <Boutons
                        onClickContinuer={this.onClickContinuer}
                        onClickEtatModaleEnregistrer={this.onClickEtatModaleEnregistrer}
                        onClickEtatModaleAnnuler={this.onClickEtatModaleAnnuler}
                        onClickEtatModaleDonnerControle={this.onClickEtatModaleDonnerControle}
                        modaleEnregistrerOuvert={this.state.modaleEnregistrerOuvert}
                        modaleAnnulerOuvert={this.state.modaleAnnulerOuvert}
                        modaleDonnerControleOuvert={this.state.modaleDonnerControleOuvert}
                        cookieParcoursAssurance={this.props.cookieParcoursAssurance}
                        informationsPreAssurabilite={this.state.informationsPreAssurabilite}
                        parcours={this.props.parcours}
                        estNouvelleMarge={this.state.informationsPreAssurabilite.estNouvelleMarge}
                      />
                    </div>
                    {this.props.parcours === TYPE_PARCOURS.AUTONOME ? (
                      <ClickToCall
                        id={"click-to-call-amc"}
                        transit={this.state.informationsPreAssurabilite.transit}
                        noDemande={this.state.informationsPreAssurabilite.noDemande}
                      />
                    ) : (
                      ""
                    )}
                  </div>
                </dsd-grid-col>
              </dsd-grid-row>
            </dsd-grid>
          </main>
        </div>
      </gabarit-global>
    );
  }
}

export default Content;
